export const WALLET_TYPES = [
  {
    id: 'bitcoin_onchain',
    apiValue: 'bitcoin_onchain',
    label: 'Bitcoin Onchain',
    shortLabel: 'Onchain',
    description: 'Salve enderecos BTC para saques onchain.',
    icon: 'bi-currency-bitcoin',
    placeholder: 'bc1q... ou 1A1z...',
  },
  {
    id: 'bitcoin_ln',
    apiValue: 'bitcoin_ln',
    label: 'Bitcoin LN',
    shortLabel: 'Lightning',
    description: 'Salve um Lightning Address ou LNURL para reuso.',
    icon: 'bi-lightning-charge-fill',
    placeholder: 'usuario@dominio.com ou lnurl1...',
  },
  {
    id: 'bitcoin_liquid',
    apiValue: 'bitcoin_liquid',
    label: 'Bitcoin Liquid',
    shortLabel: 'Liquid',
    description: 'Salve enderecos da rede Liquid para saques futuros.',
    icon: 'bi-droplet-fill',
    placeholder: 'lq1...',
  },
];

export const getWalletType = (value) => {
  const normalized = String(value || '').toLowerCase().replace(/[-\s]/g, '_');

  if (normalized.includes('lightning') || normalized.includes('ln')) {
    return WALLET_TYPES.find((type) => type.id === 'bitcoin_ln');
  }

  if (normalized.includes('liquid') || normalized.includes('liquido')) {
    return WALLET_TYPES.find((type) => type.id === 'bitcoin_liquid');
  }

  return WALLET_TYPES.find((type) => type.id === 'bitcoin_onchain');
};

const BITCOIN_MAINNET_PATTERNS = [
  /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/,
  /^bc1[a-z0-9]{25,90}$/,
];

const LIGHTNING_ADDRESS_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const LNURL_RE = /^lnurl1[a-z0-9]{10,}$/i;
const LIQUID_RE = /^(lq1|ex1|[VQ])[a-zA-Z0-9]{20,}$/;

// Removes whitespace and caps length for the address input.
export const sanitizeWalletAddress = (value) => String(value || '').replace(/\s/g, '').slice(0, 220);

// Client-side format check (fast UX feedback). The BFF/core API are authoritative and
// additionally checksum-validate on-chain addresses. Returns '' when valid.
export const validateWalletDestination = (typeId, destination) => {
  const value = String(destination || '').trim();

  if (!value) {
    return 'Informe a wallet.';
  }

  if (typeId === 'bitcoin_onchain') {
    return BITCOIN_MAINNET_PATTERNS.some((pattern) => pattern.test(value))
      ? ''
      : 'Informe um endereco Bitcoin onchain valido.';
  }

  if (typeId === 'bitcoin_ln') {
    return LIGHTNING_ADDRESS_RE.test(value) || LNURL_RE.test(value)
      ? ''
      : 'Informe um Lightning Address (usuario@dominio) ou LNURL valido.';
  }

  if (typeId === 'bitcoin_liquid') {
    return LIQUID_RE.test(value) ? '' : 'Informe um endereco Liquid valido.';
  }

  return '';
};
